enum Tokens {
  Client = 'Client',
  AuthService = 'AuthService',
  DeployService = 'DeployService',
  MetadataService = 'MetadataService',
  SalesforceService = 'SalesforceService',
  XmlService = 'XmlService',
}

export default Tokens;
